import { 
    COMMUNICATION_STATUS_BEGIN,
    COMMUNICATION_STATUS_SUCCESS,
    COMMUNICATION_STATUS_FAILURE,
    CLEAR_COMMUNICATION_STATUS,

} from 'app/actions/CommunicationStatusActions';

const initialState = {
    byId: {},
    communications: [],
    employeeData: {},
    TotalRows:0,
    isLoading: false,
};

export default function CommunicationStatus(state = initialState, action) {
    switch (action.type) {
        case COMMUNICATION_STATUS_BEGIN:
            return {
                ...state,
                isLoading: true
            }
        case COMMUNICATION_STATUS_SUCCESS:
            let communications = action.payload.data.Data;
            let TotalRows = action.payload.data.TotalRows;
            let employeeData = {
                EmployeeName: action.payload.data.EmployeeName,
                CategoryName: action.payload.data.CategoryName,
                UrlAvatar: action.payload.data.UrlAvatar
            }
            return {
                ...state,
                communications,
                employeeData,
                TotalRows,
                isLoading: false,
            };
        case CLEAR_COMMUNICATION_STATUS:
            return {
                ...state,
                communications: [],
                isLoading: false,
            }
        case COMMUNICATION_STATUS_FAILURE:
            return {
                ...state,
                isLoading: false
            }
        default:
            return state;
    }
};

export const getCommunicationStatus = state => {
    return {communicationStatus: state.communications.map(i => Object.assign(i, { TotalRows: state.TotalRows })), employeeData: state.employeeData}
}
export const getIsLoadingCommunicationStatus = state => {
    return state.isLoading;
}